import { render, staticRenderFns } from "./FormTemplateSection.vue?vue&type=template&id=50139a0c&scoped=true&"
import script from "./FormTemplateSection.vue?vue&type=script&lang=js&"
export * from "./FormTemplateSection.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateSection.vue?vue&type=style&index=0&id=50139a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50139a0c",
  null
  
)

export default component.exports